import { zValidator } from '@hono/zod-validator'
import type { ZodSchema } from 'zod'
import { ValidationError } from '../../core/errors/app-error.js'

/**
 * Validates JSON body against a Zod schema. Parsed value accessible via
 * `c.req.valid('json')` in the handler.
 */
export function validateBody<T extends ZodSchema>(schema: T) {
  return zValidator('json', schema, (result) => {
    if (!result.success) {
      throw new ValidationError(
        'Validation failed',
        result.error.errors.map((e) => ({
          path: e.path.join('.'),
          message: e.message
        }))
      )
    }
  })
}

/**
 * Validates query parameters against a Zod schema.
 */
export function validateQuery<T extends ZodSchema>(schema: T) {
  return zValidator('query', schema, (result) => {
    if (!result.success) {
      throw new ValidationError(
        'Query validation failed',
        result.error.errors.map((e) => ({
          path: e.path.join('.'),
          message: e.message
        }))
      )
    }
  })
}

/**
 * Validates path parameters against a Zod schema.
 */
export function validateParam<T extends ZodSchema>(schema: T) {
  return zValidator('param', schema, (result) => {
    if (!result.success) {
      throw new ValidationError(
        'Param validation failed',
        result.error.errors.map((e) => ({
          path: e.path.join('.'),
          message: e.message
        }))
      )
    }
  })
}
